import script from "./KitchensList.vue?vue&type=script&setup=true&lang=js"
export * from "./KitchensList.vue?vue&type=script&setup=true&lang=js"

import "./KitchensList.vue?vue&type=style&index=0&id=ce41e0d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce41e0d8"]])

export default __exports__